module.exports = __webpack_public_path__ + "static/media/LOADER_11.c4f170cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADER_11.png
// module id = 319
// module chunks = 0